/**
 * Guards against the Bifrost API being exposed when the iframe is embedded
 * on an unauthorized domain. Derived from the same check in Mystique's Bifrost
 * client (`bifrost/client/src/index.jsx`).
 */
export function isAllowedParentLocation(): boolean {
  try {
    const { host, protocol } = window.parent.location
    return (
      (protocol === 'https:' && /(?:\.jusbrasil\.com\.br|\.jusbr\.com)$/.test(host)) ||
      (/^https?:$/.test(protocol) && /^(?:dev|local)\.jusbrasil\.com\.br(?::\d+)?$/.test(host))
    )
  } catch {
    return false
  }
}
